module.exports = __webpack_public_path__ + "fonts/fa-light-300.51c6a5bf.woff";